import React from 'react';
import { Tab } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../catalyst-components/button';
import {
    ArrowLeftIcon,
    PresentationChartBarIcon,
} from '@heroicons/react/24/outline';
import { OnboardingTab } from './components/OnboardingTab';
import { EngagementTab } from './components/EngagementTab';
import { GrowthTab } from './components/GrowthTab';
import { RetentionTab } from './components/RetentionTab';

const tabs = [
    { name: 'Onboarding & Demographics', component: OnboardingTab },
    { name: 'Engagement & Activity', component: EngagementTab },
    { name: 'Growth & Leveling', component: GrowthTab },
    { name: 'Retention & Economy', component: RetentionTab },
];

export const EngagementAnalytics: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background pt-24">
            {/* Header */}
            <div className="border-b border-border/50 bg-gradient-to-r from-green-50 to-green-100/50 px-6 py-8">
                <div>
                    <div className="flex items-center gap-4 mb-4">
                        <Button color="secondary" className="rounded-full" onClick={() => navigate('/admin')}>
                            <ArrowLeftIcon className="h-4 w-4 mr-2" />
                            Back
                        </Button>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="p-3 rounded-xl bg-white border-2 border-green-200">
                            <PresentationChartBarIcon className="h-8 w-8 text-primary" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-semibold text-foreground mb-1">Engagement Analytics</h1>
                            <p className="text-base text-muted-foreground">
                                Onboarding, engagement, progression, retention, and economy metrics
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
                <div>
                    <Tab.Group>
                        <Tab.List className="flex flex-wrap gap-2 mb-8">
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.name}
                                    className={({ selected }) =>
                                        `px-4 py-2 rounded-full text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50 ${
                                            selected
                                                ? 'bg-primary text-white shadow-sm'
                                                : 'bg-card border-2 border-border/50 text-muted-foreground hover:text-foreground hover:border-primary/30'
                                        }`
                                    }
                                >
                                    {tab.name}
                                </Tab>
                            ))}
                        </Tab.List>
                        <Tab.Panels>
                            {tabs.map((tab) => (
                                <Tab.Panel key={tab.name}>
                                    <tab.component />
                                </Tab.Panel>
                            ))}
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>
        </div>
    );
};
